export const EVENTS = {
  NO_MORE_BETS: 'round.no_more_bets',
  PLACE_YOUR_BETS: 'round.place_your_bets',
  GAME_RESULT: 'round.game_result',
  GAME_START: 'game.start',
  APP_START: 'app_start',
  AUTH_SUCCESS: 'auth_success',
  ENTER_FULLSCREEN: 'enter_fullscreen',
  EXIT_FULLSCREEN: 'exit_fullscreen',
  REQUEST_HOME: 'request_home',
  REQUEST_CASHIER: 'request_cashier',
  ACCESS_RESTRICTED: 'access_restricted',
  ERROR_SET: 'error_set',
  DIALOG_ADD: 'dialog_add',
  VOLUME_SET: 'volume_set',
  MOBILE_USER_INTERACTION: 'mobile_user_interaction',
  PLAYER_JOINED_TABLE: 'player.joined.table',
  PLAYER_LEFT_TABLE: 'player.left.table',
  ROUND_SET: 'round_set',
  SET_TOTAL_BET: 'set_total_bet',
};
